<div class="modal modal_pb_40 modal_size_744 modal__opened">
  <div class="modal__backlink with-icon" *ngIf="!newContact && !rulesSaved" (click)="back()">{{ 'edit-contact-modal.back' | translate }}</div>

  <div class="modal__close icon icon-close" (click)="close()"></div>

  <ng-container [ngTemplateOutlet]="contactEdit" *ngIf="!showRules && !rulesSaved"></ng-container>

  <app-rules-block *ngIf="showRules && !rulesSaved" [contact]="contact" [rules]="rules" (saveRules)="saveRules($event)" (deleteRules)="deleteRules()"
                   [requestInProgress]="requestInProgress"></app-rules-block>

  <ng-container [ngTemplateOutlet]="ruleSaved" *ngIf="rulesSaved"></ng-container>
</div>

<ng-template #contactEdit>
  <div class="modal__container">
    <div class="modal__title h2">{{ (newContact ? 'edit-contact-modal.add-contact' : 'edit-contact-modal.edit-contact') | translate }}</div>
    <div class="modal__content modal__content-w375px">
      <div class="modal__form-field">
        <div class="input input_width_auto">
          <label class="input__label">{{ 'edit-contact-modal.name' | translate }}</label>
          <div class="input__container">
            <input type="text" [placeholder]="'edit-contact-modal.name-placeholder' | translate" class="input__input" [(ngModel)]="title"
                   (ngModelChange)="contactFieldChanged()" maxlength="50" [patterns]="titlePattern" [specialCharacters]="[]" mask="T{50}"/>
          </div>
        </div>
      </div>
      <div class="modal__form-field">
        <div class="input input_width_auto" [class.input_type_error]="msisdnError">
          <label class="input__label">{{ 'edit-contact-modal.phone-number' | translate }}</label>
          <div class="input__container">
            <input type="text" placeholder="+7 000 000-00-00" class="input__input" [(ngModel)]="msisdn" mask="+0 000 000-00-00" (ngModelChange)="msisdnChanged()"/>
          </div>
        </div>
        <div class="input__error" *ngIf="msisdnError">{{ msisdnError | translate }}</div>
      </div>
    </div>
  </div>
  <div class="modal__buttons modal__buttons-mt72">
    <div class="button" [class.button_status_disabled]="!nextActive" [class.button_type_load]="requestInProgress"
         (click)="saveContact()">{{ 'edit-contact-modal.next' | translate }}
    </div>
  </div>
</ng-template>
<ng-template #ruleSaved>
  <div class="modal__container">
    <div class="modal__img">
      <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
    </div>
    <div class="modal__title modal__title-mb12 h2">{{ 'edit-contact-modal.rules-saved' | translate }}</div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button" (click)="close()">{{ 'edit-contact-modal.ok-btn' | translate }}</div>
  </div>
</ng-template>
